import {IInvoiceDTO} from "@/interface";
import {PaymentTypeEnum} from "@/enums";
import {DateHelper} from "@/mega-ui/helpers/function"
import {InvoiceContextEnum} from "@/enums/invoices/invoice-context.enum";

export class Invoice {
    invoiceDate: Date;
    debitInvoiceDate: Date;
    totalWithVat: number;
    invoiceCommunication: string;
    invoiceId: string;
    invoiceUuid: string;
    invoiceContext: InvoiceContextEnum;

    constructor(base?: Partial<Invoice>) {
        if (base) {
            Object.assign(this, base);
        }
    }

    public static fromDto(dto: IInvoiceDTO, isPaid: boolean) {
        if (!dto) {
            return null;
        }

        return new Invoice({
            invoiceDate: new Date(dto.dates.invoice_generated_at),
            debitInvoiceDate: new Date(dto.dates.due_date),
            totalWithVat: +dto.total.total_incl_vat,
            invoiceCommunication: dto.mercator.mercator_communication,
            invoiceId: dto.mercator.mercator_piece,
            invoiceUuid: dto.uuid,
            invoiceContext: isPaid ? InvoiceContextEnum.IS_PAID : this.getPendingDD(dto)
        });
    }

    private static getPendingDD(dto: IInvoiceDTO){

        return dto.details.payment_mode === PaymentTypeEnum.BT ?
            InvoiceContextEnum.TO_PAID :
            DateHelper.isAfterOrSame(new Date(dto.dates.due_date), new Date()) ?
                InvoiceContextEnum.DD_PENDING :
                InvoiceContextEnum.DD_FAILED
    }
}
